import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const navItems = [{
  id: 'overview',
  label: 'Overview'
}, {
  id: 'budget',
  label: 'Budget'
}, {
  id: 'keywords',
  label: 'Keywords'
}, {
  id: 'targeting',
  label: 'Targeting'
}, {
  id: 'projections',
  label: 'Projections'
}, {
  id: 'timeline',
  label: 'Timeline'
}];
export function ProposalNav() {
  const [activeSection, setActiveSection] = useState('overview');
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
      const sections = navItems.map(item => document.getElementById(item.id));
      const scrollPosition = window.scrollY + 150;
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(navItems[i].id);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md' : 'bg-transparent'}`} data-id="element-242">
      <div className="max-w-6xl mx-auto px-6 py-4" data-id="element-243">
        <div className="flex items-center justify-between" data-id="element-244">
          <div className="flex items-center gap-3" data-id="element-245">
            <img src="https://cdn.magicpatterns.com/uploads/rPECazqhHrWF2aBnEWg3gz/beclinical_logo_2.svg" alt="Be Clinical" className="h-8 w-auto" data-id="element-246" />
            <span className={`text-sm font-medium transition-colors ${isScrolled ? 'text-[#1B2A4A]' : 'text-[#1B2A4A]/70'}`} data-id="element-247">
              Campaign Proposal
            </span>
          </div>

          <div className="hidden md:flex items-center gap-1" data-id="element-248">
            {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className={`relative px-4 py-2 text-sm font-medium transition-colors rounded-full ${activeSection === item.id ? 'text-[#1B2A4A]' : 'text-[#666] hover:text-[#1B2A4A]'}`} data-id="element-249">
                {activeSection === item.id && <motion.div layoutId="activeNav" className="absolute inset-0 bg-[#C9A96E]/20 rounded-full" transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-250" />}
                <span className="relative z-10" data-id="element-251">{item.label}</span>
              </button>)}
          </div>
        </div>
      </div>
    </motion.nav>;
}